import React from "react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
}

const SetupAccount: React.FC<TaskCardProps> = ({ task }) => {
  const { t } = useTranslation("tasks");

  return (
    <TaskCard
      task={task}
      title={t("setupAccount.title")}
      description={t("setupAccount.description")}
      actionHref="/account"
      actionText={t("setupAccount.finishSetup")}
      externalLink={false}
    />
  );
};

export default SetupAccount;
